import { createSlice } from "@reduxjs/toolkit";
import {getCategoryProductPerformanceThunk, getKeyMetricsThunk, getQSDBThunk, getSellerPerformanceThunk } from "./thunk";
// import {  getIcomeOverViewThunk, getIncomeDetailThunk, getOrderIncomeStatementThunk, getStatementOrderDetailThunk } from "./thunks";

export const initialState: any = {
  getSellerPerformance: [],
  getKeyMetrics: {},
  keymetricsCount: {},
  getegoryProductPerformance:{},
  qsdb:{}
};

const SellerPerformance = createSlice({
  name: "SellerPerformanceSLice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSellerPerformanceThunk.fulfilled, (state: any, action: any) => {
      state.getSellerPerformance = action.payload.data;
      state.counts = action.payload.counts;
    });

    builder.addCase(getSellerPerformanceThunk.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });

    builder.addCase(getKeyMetricsThunk.fulfilled, (state: any, action: any) => {
      state.getKeyMetrics = action.payload.timestamp;
      state.keymetricsCount = action.payload.counts
    });
    builder.addCase(getKeyMetricsThunk.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });


     builder.addCase(getCategoryProductPerformanceThunk.fulfilled, (state: any, action: any) => {
      state.getegoryProductPerformance = action.payload;
      state.counts = action.payload.counts;
    });

    builder.addCase(getCategoryProductPerformanceThunk.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });

   builder.addCase(getQSDBThunk.fulfilled, (state: any, action: any) => {
      state.qsdb = action.payload;
    });

    builder.addCase(getQSDBThunk.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    
  },
});

export default SellerPerformance.reducer;
